import React from 'react';
import { CheckmarkOutline24 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';

const SuccessPage: React.FC<Props> = ({ handleCancel }) => {
  return (
    <div className="feedback --swx-theme--dark">
      <div className="panel-title bx--switcher__item">
        <div className="bx--switcher__item-link no-clickable">
          Thanks for your feedback
        </div>
      </div>
      <div className="feedback-form">
        <div className="feedback-form-success spacing">
          <section className="feedback-form-success-item">
            <CheckmarkOutline24 className="success-icon" />
          </section>
          <section className="feedback-form-success-item">
            <div className="wording-styling">
              The SmarterWX product team will review your feedback. Your
              suggestions help to improve this product.
            </div>
          </section>
        </div>
        <div className="divider"></div>
        <div className="feedback-form-buttons spacing">
          <Button
            id="close"
            name="close"
            kind="secondary"
            data-testid="close"
            onClick={
              typeof handleCancel === 'function'
                ? () => handleCancel()
                : undefined
            }
            className="close-button"
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

type Props = {
  handleCancel?: Function;
};

export default React.memo(SuccessPage);
